import { FC, useRef, useState } from "react"
import imageEmail from '../../../assets/images/emailImage.png'
import './validate.css'
import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { Loading } from "../../../components/Loading";
import useAuth from "../../../hooks/useAuth";

const ValidateCodeReset: FC = () => {

    const [code, setCode] = useState(['', '', '', '']); // Array para armazenar cada dígito
    const inputRefs = useRef<any>([]);
    const navigate = useNavigate()
    const { pluginspace_id } = useParams();
    const { getToken } = usePluginspace();
    const [loading, setLoading] = useState(false);
    const { setToken, setPluginspaceData } = usePluginspace()
    const { setLoginInfo } = useAuth()


    const handleChange = (e: any, index: number) => {
        const { value } = e.target;
        if (/^\d$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (index < 3) {
                inputRefs.current[index + 1].focus();
            }
        } else if (value === '' && index > -1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            inputRefs.current[index === 0 ? index : index - 1].focus();
        }
    };


    const validar = async () => {
        try {
            setLoading(true)
            const cpf = localStorage.getItem('cpfReset')
            const payload = {
                cpf: cpf,
                validationCode: code.join('')
            }
            await api
                .post(
                    `/api/customer/valid_code_password`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then(async (response: any) => {
                    setLoading(false)



                    const data = response.data

                    console.log(data)
                    if (!data || !data.success) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro na validação do código,tente novamente!',
                        })
                        return
                    }

                    if (data || data.success) {
                        navigate('reset')
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro na validação do código,tente novamente!',
                        })
                    }

                })
                .catch((err: any) => {
                    setLoading(false)
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro na validação do código,tente novamente!',
                    })

                    console.log(err);
                });
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }



    return (
        <>{
            loading ?
                (
                    <Loading
                        type="spinningBubbles"
                        color="#FFF"
                        width={64}
                        height={64}
                    />
                ) : (
                    <>
                        <div className="validateContent">
                            <div className="validateImage">
                                <img src={imageEmail} alt="Logo" />
                            </div >


                            <div className="validateText">
                                <h3>Esqueci a senha - Validar email</h3>
                            </div>
                            <div className="validateText" >
                                <span>Enviamos uma mensagem para o seu email com um código de 4 digitos.</span>
                            </div>
                            {/* Fazer os campos de confirmação de codigo */}
                            <div className="confimCode">
                                {code.map((digit, index) => (
                                    <div className="digit-input">
                                        <input
                                            key={`${index}-${digit}`}
                                            type="text"
                                            className="classInput"
                                            value={digit}
                                            onChange={(e) => handleChange(e, index)}
                                            //onKeyDown={(e) => handleKeyDown(e, index)}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div className="msgSendAgain">
                                <span>Não recebeu a mensagem?</span>
                                <a>Clique aqui para enviar novamente</a>
                            </div>


                            <div className="buttonValidate">
                                <button
                                    onClick={() => validar()}
                                >Validar</button>
                            </div>


                          {
                            /**  <div className="msgProblem">
                                <span>Problema para receber a mensagem?</span>
                                <a>Clique aqui para utilizar outro email</a>
                            </div> */
                          }
                        </div >
                    </>
                )

        }
        </>
    )
}

export { ValidateCodeReset }